import React from 'react';
import AiDetails from '../../components/news/ai/AiDetails';

function AI() {
    return (
        <div>
            <AiDetails />
        </div>
    )
}

export default AI;
